import React from 'react'
import useAuthentication from '../services/useAuthentication';
import { Navigate } from 'react-router-dom'

const PublicRoutes = ({ component }) => {
    const { isAuthenticated } = useAuthentication();
    if (!isAuthenticated) {
        return <>{component}</>;
    }

    return <Navigate to='/bookedslot' />

}

export default PublicRoutes